import styled from 'styled-components';
import { FormHelperText } from '@material-ui/core';
import SelectCountry from '../../../../components/SelectCountry';
import colors from '../../../../styles/theme/colors';
import { sizes } from '../../../../styles/theme/devices';
import spaces from '../../../../styles/theme/spaces';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 ${spaces.xs};
  overflow: visible;

  @media (min-width: ${sizes.tablet}) {
    padding: 0;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #25d366;
  margin-bottom: ${spaces.xs};

  svg {
    color: ${colors.default.white};
    font-size: 28px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spaces.xs};
`;

const Title = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.gray[800]};
  text-align: center;
  margin: 0 0 ${spaces.micro} 0;

  @media (min-width: ${sizes.tablet}) {
    font-size: 20px;
  }
`;

const Description = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: ${colors.gray[500]};
  text-align: center;
  margin: 0 0 ${spaces.small} 0;
  line-height: 1.5;
  max-width: 400px;

  @media (min-width: ${sizes.tablet}) {
    font-size: 14px;
  }
`;

const PhoneFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 420px;
  overflow: visible;
`;

const PhoneInputsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  overflow: visible;
`;

const SelectCountryField = styled(SelectCountry)`
  width: 115px;
  flex-shrink: 0;
  height: 56px;
  overflow: visible;

  & > div {
    height: 56px;
    padding-bottom: 0;
  }

  button {
    box-sizing: border-box;
    height: 56px;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.23);

    &:hover {
      border-color: rgba(0, 0, 0, 0.87);
    }

    &:focus {
      border: 2px solid #fb8c00;
    }
  }
  
  .ReactFlagsSelect-module_fullWidthOptions__1XeR6,
  [class*='selectOptions'] {
    border: 1px solid rgba(0, 0, 0, 0.23) !important;
    border-radius: 8px !important;
    scrollbar-width: thin;
    scrollbar-color: ${colors.gray[100]} transparent;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${colors.gray[100]};
      border-radius: 16px;
      border: 2px solid transparent;
      background-clip: content-box;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      margin: 4px 0;
    }
  }

  .ReactFlagsSelect-module_filterBox__3m8EU input,
  [class*='filterBox'] input {
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 8px;
    outline: none;
    box-shadow: none;

    &:focus {
      border-color: #fb8c00;
      outline: none;
      box-shadow: none;
    }
  }
    
`;

const PhoneField = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;

  .MuiFormControl-root,
  .MuiTextField-root {
    margin: 0;
    width: 100%;
  }

  .MuiOutlinedInput-root {
    height: 56px;
    border-radius: 8px;
  }

  .MuiOutlinedInput-input {
    padding: 16.5px 14px;
    box-sizing: border-box;
  }

  .MuiOutlinedInput-input::placeholder {
    font-size: 13px;
  }

  @media (min-width: ${sizes.tablet}) {
    .MuiOutlinedInput-input::placeholder {
      font-size: 14px;
    }
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #fb8c00;
    border-width: 2px;
  }

  .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: #fb8c00;
  }

  .MuiOutlinedInput-root.Mui-error:hover .MuiOutlinedInput-notchedOutline {
    border-color: #fb8c00;
  }

  .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #fb8c00;
    border-width: 2px;
  }
`;

const PhoneHelperText = styled(FormHelperText)`
  && {
    margin-left: 14px;
    margin-top: 3px;
    margin-bottom: 0;
  }
`;

export {
  Container,
  IconWrapper,
  Title,
  TitleContainer,
  Description,
  PhoneFieldsContainer,
  PhoneInputsRow,
  SelectCountryField,
  PhoneField,
  PhoneHelperText,
};
